var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefreshAirInactiveMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,39.5859375l-3.2929688-3.2929688l-1.4140625,1.4140625l3.2647095,3.2647095C24.3709106,40.9778442,24.1882324,41,24,41 c-9.3740234,0-17-7.6259766-17-17c0-7.2597656,4.5825195-13.4534912,11-15.8859863V5.9862671C10.4577637,8.5056763,5,15.62146,5,24 c0,10.4765625,8.5234375,19,19,19c0.208313,0,0.4104614-0.0245361,0.6171875-0.03125l-3.3242188,3.3242188l1.4140625,1.4140625 L26.4140625,44l1.2929688-1.2929688c0.390625-0.390625,0.390625-1.0234375,0-1.4140625L26,39.5859375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,8.4140625l3.2929688,3.2929688l1.4140625-1.4140625l-3.2647095-3.2647095C23.6290894,7.0221558,23.8117676,7,24,7 c9.3740234,0,17,7.6259766,17,17c0,2.8912964-0.7296753,5.6137695-2.0081787,8h2.2177124 C42.3464355,29.5645752,43,26.8602295,43,24c0-10.4765625-8.5234375-19-19-19c-0.208313,0-0.4104614,0.0245361-0.6171875,0.03125 l3.3242188-3.3242188l-1.4140625-1.4140625L20.5859375,5l-0.2929688,0.2929688c-0.390625,0.390625-0.390625,1.0234375,0,1.4140625 L22,8.4140625z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.7070312,34.7070312 45.2929688,33.2929688 40,38.5859375 34.7070312,33.2929688 33.2929688,34.7070312  38.5859375,40 33.2929688,45.2929688 34.7070312,46.7070312 40,41.4140625 45.2929688,46.7070312 46.7070312,45.2929688  41.4140625,40  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshAirInactiveMedium);
export default __webpack_public_path__ + "static/media/refresh-air-inactive--medium.9d2fb72c2765bcdfbda9b59267324f0a.svg";
export { ForwardRef as ReactComponent };